import "./src/styles/tailwind.css";
import * as React from "react";
import { AuthProvider } from "./src/contexts/AuthContext";
import { ShopProvider } from "./src/contexts/ShopContext";

export const wrapRootElement = ({ element }) => (
  <AuthProvider>
    <ShopProvider>{element}</ShopProvider>
  </AuthProvider>
);
